import type { ISyteResult } from '@condo/domain';
import { getClient } from '@/api/api-client';

export async function fetchSyteBuildingData(mfhId: number): Promise<ISyteResult> {
    const { data } = await getClient('basecamp').get<ISyteResult>(`/mfhs/${mfhId}/syte/building`);
    return data;
}

export async function fetchSyteBuildingGltf(mfhId: number, buildingIdentifier: string): Promise<Blob> {
    const { data } = await getClient('basecamp').get<Blob>(`/mfhs/${mfhId}/syte/gltf/${encodeURIComponent(buildingIdentifier)}`, {
        responseType: 'blob',
    });
    return data;
}
